

/**
 * @ngdoc directive
 * @name prohealth.directive:Header Notification
 * @description
 * # PosHeader
 */
(function () {
    'use strict';
    angular.module('myApp')
        .directive('headerNotificationNew', headerNotificationNew);

    function headerNotificationNew() {
        var directiveObj = {};
        directiveObj.bindToController = {
            notificationcount: '=',
            changepasswordpopup: '&',
            changepassword: '&',
            currentpassword: '='
        }
        directiveObj.controller = HeaderController;
        directiveObj.controllerAs = 'vm';
        directiveObj.templateUrl = 'js/scripts/directives/header-new/header-notification-new/header-notification-new.html',
            directiveObj.restrict = 'E';
        directiveObj.replace = true;
        return directiveObj;
    }
    function HeaderController($scope, $state, authApi, $localStorage, $loading, ngDialog, $http, Api,
                              $sessionStorage, shareProfile, sessionService) {
        var vm = this;
        vm.user = {};
        vm.logout = authApi.logout;
        vm.goToState = goToState;
        vm.shareProfile = shareProfile.share;
        $scope.subscription = sessionService.professionalData
            .subscribe((data) =>{
                if(data){
                    const {firstName, profilePicThumbUrl} = data;
                    vm.user = {firstName, profilePicThumbUrl};
                }
            });
        $scope.$on('$destroy', $scope.subscription);

        function goToState(state) {
            $loading.start('splash');
            $state.go(state);
        }
    }
})();

